export const getNativeErrorMessage = (error: unknown) => {
	const e = error as Error;

	return e?.message || '';
};
